import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { logout } from '../store/slices/authSlice';
import { hasPermission } from '../utils/permissions';
import { PERMISSIONS } from '../config/permissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  const isAuthorized =
    isAuthenticated && hasPermission(user?.permissions, PERMISSIONS.CHATBOT_ADMIN);

  // If state is hydrated from a tampered/stale localStorage and lacks the
  // required permission, clear it so subsequent visits also start clean.
  useEffect(() => {
    if (isAuthenticated && !isAuthorized) {
      dispatch(logout());
    }
  }, [isAuthenticated, isAuthorized, dispatch]);

  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
